module.exports = __webpack_public_path__ + "static/resume-b87af9b536d059e6859659c9b48779ba.pdf";